export * from './datadog-browser-adapter';
